import React from 'react';

import { getVideoEmbedUrl } from 'lib/src/utils/generic';
import { ChallengeDescriptionSectionContent } from 'src/types/shared/Challenge';

const Video: React.FC<VideoProps> = ({ data }) => {
    const url = getVideoEmbedUrl(data.content);

    if (!url) return null;

    return (
        <div className="video">
            <iframe
                width="560"
                height="315"
                src={url}
                title="Video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
            {data.title && <p>{data.title}</p>}
        </div>
    );
};

interface VideoProps {
    data: ChallengeDescriptionSectionContent;
}

export default Video;
